import {MD5} from './md5'
import { getExplore, getOsInfo, uuid, fudid, getYMD } from './index'
import $store from '@/store/index'
import $router from '@/router/index'
import cookie from '@/assets/js/cookie'


class BaseParam {
    constructor(){
        this.base_params = {
            'product'    : 'baofeng',
            'client'     : $store.state.common.cl,
            'dev'        : `<${getOsInfo()}>_<${getExplore()}>`,
            'ver'        : $store.state.version,
            'clienttime' : new Date().valueOf(),
            'sc'         : null,
            'uuid'       : uuid(),
            'fudid'      : fudid(),
            'imei'       : '',
        }
        this.common_url = 'http://stat.funshion.com/baofeng/'
        this.getSc()
    }
    getSc(){
        var time = getYMD(),
            type = 'bootstrap',
            product = this.base_params.product,
            client = this.base_params.client,
            fudid = this.base_params.fudid;
        var sc = MD5(time + type + product + client + fudid).substring(0,9);
        this.base_params['sc'] = sc;
    }
    init(){
        this.bootstrapLog()
        this.bindClick()
    }
    bootstrapLog(){
        var data = {
            'ptype': '1',
            'ok'   : '1',
            'sr'   : window.screen.width + '*' + window.screen.height
        }
        var param = Object.assign({}, data, this.base_params);
        var _url = this.common_url + 'bootstrap' + '?' + this.formateParams(param);
        this.sendLog(_url)
    }
    clickLog(p){
        var data = {
            'yp'       : 'dh',
            'dh'       : $router.currentRoute.params.id,
            // 'bl'       : '',
            // 'template' : '',
            // 'mid'      : '',
            // 'mstp'     : '',
            // 'vid'      : '',
            // 'vstp'     : ''
        }
        data = Object.assign( {}, p, this.base_params);
        var _url = this.common_url + 'click' + '?' + this.formateParams(data);
        this.sendLog(_url)
    }
    formateParams(param){
        var str = '';
        for(let key in param){
            str += `&${key}=${param[key]}`
        }
        return str.substring(1)
    }
    sendLog(url){
        var img = document.createElement('img');
        img.src = url;
        img.onload = function(){
            img
        }
    }
    bindClick(){
        var doms = document.getElementsByClassName('log-click');
        setTimeout(() => {
            doms = Array.prototype.slice.call(doms);
            doms.forEach( (item) => {
                item.addEventListener('click', () => {
                    let p = {
                        'bl' : item.getAttribute('data-blockid'),
                        'template': item.getAttribute('data-template'),
                        'mid': item.getAttribute('data-mid') || '',
                        'mstp': item.getAttribute('data-stp') || '',
                        'vid': item.getAttribute('data-vid') || '',
                        'vstp': item.getAttribute('data-stp') || ''
                    }
                    this.clickLog(p)
                })
            })
        }, 1000);
    }
}
let report = new BaseParam();
report.init()
$router.afterEach( () => {
    report.init()
})

$router.beforeEach((to, from, next) => {
  const login_info = cookie.get('bf_login_user')
  if(!login_info && to.path === '/profile'){
    next('/');
  }
  next();
})


// WEBPACK FOOTER //
// ./src/utils/log.js